import React, { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Maverick Legacy Foundation';
  }, []);
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <HeroSection data-id="element-2" />
      <MissionSection data-id="element-3" />
      <AboutSection data-id="element-4" />
      <ContactSection data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}